import React from "react";

import {
  SectionContainer,
  Title,
  Description,
  RowContainerBig
} from "./styled-components";

const SuccessHeaderRegistrationMolecule = (props) => {
  const { title, description } = props;

  return (
    <SectionContainer>
      <RowContainerBig>
        <Title data-qa-label="success-header-title">{title}</Title>
      </RowContainerBig>
      <RowContainerBig>
        <Description data-qa-label="success-header-description">
          {description}
        </Description>
      </RowContainerBig>
    </SectionContainer>
  );
};

SuccessHeaderRegistrationMolecule.defaultProps = {
  title: "",
  description: ""
};

export default SuccessHeaderRegistrationMolecule;
